import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import { setFavorite, unsetFavorite } from '../../../../../redux/actions/favorites'
import { getClientNovelties, getNovelties, showNoveltyBySlug, toggleFormNovelty } from '../../../../../redux/actions/novelties'
import { IRootState } from '../../../../../redux/types'
import useUserDisplaytime from '../../../../shared/hooks/useUserDisplaytime'
import { MoreInfoDetail } from '../../../library/models/resource'
import { INovelty } from '../../models/novelties'

dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)

export const useNoveltyDetail = (t: (key: string) => string) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { slug } = useParams<{ slug: string }>()

  const { novelties, noveltySelected, showForm } = useSelector((state: IRootState) => state.novelty)
  const { globalFamilyId, globalBrandId, globalCountryId, globalLanguageId, globalCountriesId } = useSelector(
    (state: IRootState) => state.global
  )
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  const [sortNovelties, setSortNovelties] = useState<INovelty[]>([])
  const [content, setContent] = useState<string>('')
  const [favoriteState, setFavoriteState] = useState<boolean>(false)

  const isAdmin = location.pathname.includes('admin')

  useUserDisplaytime({ foreign: noveltySelected })

  useEffect(() => {
    dispatch(showNoveltyBySlug({ slug, type: 'noveltySelected' }))
    const handleShortcutClick = () => {
      console.log('Click addeventlistener')
    }
    const btnElement = document.getElementById('btn-shortcutseminars')
    if (btnElement) {
      btnElement.addEventListener('click', handleShortcutClick)
      return () => btnElement.removeEventListener('click', handleShortcutClick)
    }
  }, [slug, dispatch])

  useEffect(() => {
    if (noveltySelected !== null) {
      setFavoriteState(Boolean(noveltySelected.favoriteId))
      if (noveltySelected.content && noveltySelected.content.search('{mostrarSeminario}') >= 0) {
        // En lugar de usar renderToString, vamos a marcar este punto para renderizar después
        // en el componente, no en el hook
        setContent(noveltySelected.content)
      } else if (noveltySelected.content) {
        setContent(noveltySelected.content)
      }
    }
  }, [noveltySelected])

  useEffect(() => {
    if (novelties.length > 0) {
      const tmpSortNovelties = [...novelties]
      tmpSortNovelties.sort((a: any, b: any) => {
        if (a.id > b.id) return -1
        if (a.id < b.id) return 1
        return 0
      })
      setSortNovelties(tmpSortNovelties)
    }
  }, [novelties])

  useEffect(() => {
    if (novelties.length === 0) {
      if (isAdmin) {
        dispatch(
          getNovelties({
            family_id: globalFamilyId,
            brand_id: globalBrandId,
            language_id: globalLanguageId,
            countries: globalCountriesId,
            requesttype: 0,
            type: 'novelties'
          })
        )
      } else if (authUser !== null) {
        dispatch(
          getClientNovelties({
            family_id: globalFamilyId,
            brand_id: globalBrandId,
            country_id: globalCountryId,
            language_id: globalLanguageId,
            type: 'novelties',
            requesttype: 0
          })
        )
      }
    }
  }, [globalFamilyId, globalBrandId, globalCountryId, globalLanguageId, globalCountriesId, isAdmin, authUser, novelties.length, dispatch])

  const handleShowNovelty = (slug: string) => {
    dispatch(showNoveltyBySlug({ slug, type: 'noveltySelected' }))
  }

  const cutContent = (content: string) => {
    let trimmedString: string = ''
    const endIndex = content.indexOf('</p>')
    trimmedString = content.substring(0, endIndex > -1 ? endIndex : content.length)
    return trimmedString
  }

  const handleFavoriteClick = (novelty_id: number) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id: novelty_id,
          type: 'novelty'
        })
      )
    } else {
      dispatch(
        unsetFavorite({
          id: novelty_id,
          type: 'novelty'
        })
      )
    }
    setFavoriteState(state)
  }

  const handleToggleForm = () => {
    dispatch(toggleFormNovelty({ type: 'noveltySelected', change: false }))
  }

  const getInfoDetail = (): MoreInfoDetail => ({
    item: [
      {
        id: 0,
        type: 'tag',
        title: 'Tags',
        color: 'light',
        info: `${noveltySelected?.tags
          ?.map((tag: any) => {
            return tag.name.toUpperCase()
          })
          .join(', ')}`
      },
      {
        id: 1,
        type: 'date',
        title: `${t('admin.people.created-date')}`,
        color: 'grey6',
        info: `${dayjs(noveltySelected?.created_at).format('LL')}`
      }
    ]
  })

  return {
    isAdmin,
    noveltySelected,
    showForm,
    sortNovelties,
    content,
    favoriteState,
    authUser,
    infoDetail: getInfoDetail(),
    handleShowNovelty,
    cutContent,
    handleFavoriteClick,
    handleToggleForm
  }
}
